import { createRoute } from "@tanstack/solid-router";
import { lazy, Suspense } from "solid-js";
import { appRoute } from "./route";

const CategoryManager = lazy(async () => {
  const m = await import("@/features/categories/components/category-manager");
  return { default: m.CategoryManager };
});

function CategoriesPage() {
  return (
    <Suspense fallback={null}>
      <CategoryManager />
    </Suspense>
  );
}

interface CategoriesSearch {
  /** Active tab; `expense` is the default and is omitted. */
  kind?: "income";
  /** Expanded category (view subcategories): `?open=<catId>`. */
  open?: string;
  /** Creation dialog open: `?new=1`. */
  new?: 1;
  /** Parent category of new subcategory: `?parent=<catId>`. */
  parent?: string;
  /** Rename category: `?edit=<catId>`. */
  edit?: string;
  /** Merge category (choose destination): `?merge=<catId>`. */
  merge?: string;
}

function asStr(value: unknown): string | undefined {
  return typeof value === "string" && value.length > 0 ? value : undefined;
}

/** validateSearch: tab + expansion + create/rename/merge dialogs in the URL. */
function sanitizeCategoriesSearch(search: Record<string, unknown>): CategoriesSearch {
  const isNew = search.new === true || search.new === "1" || search.new === 1;
  const edit = asStr(search.edit);
  const merge = asStr(search.merge);
  return {
    kind: search.kind === "income" ? "income" : undefined,
    open: asStr(search.open),
    new: isNew && edit === undefined && merge === undefined ? 1 : undefined,
    parent: asStr(search.parent),
    edit,
    merge,
  };
}

export const categoriesRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/categories",
  validateSearch: sanitizeCategoriesSearch,
  component: CategoriesPage,
});
